import styled from '@emotion/styled';
import { ListItemButton, ListItemIcon, ListItemText, ListItem as MUIListItem, Typography } from '@mui/material';
import React from 'react';

interface BaseListItemProps {
    title: string,
    description?: string,
    icon: JSX.Element,
    color?: string,
    onClick?: () => void,
    secondaryAction?: JSX.Element;
}

const BaseListItem: React.FC<BaseListItemProps> = ({ title, description = '', icon, color, onClick = () => { }, secondaryAction }) => {
    const handleSecondaryActionClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
    };
    return (
        <StyledListItemButton onClick={onClick}>
            <StyledListItem
                secondaryAction={
                    <div onClick={handleSecondaryActionClick}>
                        {secondaryAction}
                    </div>
                }
                disableGutters>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography color={color} lineHeight={1} fontWeight={600} variant="subtitle2">
                            {title}
                        </Typography>
                    }
                    secondary={
                        <Typography variant='caption' color={"text.secondary"}>
                            {description}
                        </Typography>
                    } />
            </StyledListItem>
        </StyledListItemButton>
    )
}

export default BaseListItem;

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    borderRadius: 8,
    paddingTop: 6,
    paddingBottom: 6,
    ":hover": {
        "& #base-list-item-right-icon": {
            marginRight: -4
        },
    }
}))

const StyledListItem = styled(MUIListItem)(({ theme }) => ({
}))